import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const configuration = _configuration

export const userTypes = {
    admin: "administrator",
    worker: "worker",
    supplier: "supplier",
    customer: "customer",
    driver: "driver",
    retail: "retailer",
    member: "member",
}

export const targetTypes = {
    admin: "administrator",
    worker: "worker",
    supplier: "supplier",
    customer: "customer",
    driver: "driver",
    retail: "retailer",
    member: "member",
}

export function useUsers({
    jwtToken: _jwtToken,
    userType: _userType,
    targetType: _targetType
}) {

    const [userType, setUserType] = useState(_userType);
    const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, serverClient, getError } = useServerClient(_jwtToken);
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "user";
    const endpoint2 = "users"

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            let url = getListsUrl(`${endpoint2}/${userType}`, props);

            // check override 
            if (props?.userType) {
                url = getListsUrl(`${endpoint2}/${props.userType}`, props);
            }

            // if (targetType) {
            //     url = getListsUrl(`${endpoint2}/${userType}/${targetType}`, props);
            // }

            // specially for retail member only
            // if (userType === userTypes.member) {
            //     url = getListsUrl(`${endpoint1}/members/${targetType}`, props);
            // }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            // setIsLoading(false);
            // throw error;

            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true;
    }

    const create = async ({ data, scopeType: overrideUserType, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}`;

            // if (overrideUserType) {
            //     url = `${endpoint1}/${overrideUserType}`;
            // }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, scopeType: overrideUserType, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}/${id}`

            // if (overrideUserType) {
            //     url = `${endpoint1}/${overrideUserType}/${id}`
            // }

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, scopeType: overrideUserType, targetType: overrideTargetType }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint2}/delete`

            // if (overrideUserType) {
            //     url = `${endpoint1}/${overrideUserType}/delete`
            // }

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, userType: overrideUserType, dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint1}/${userType}/${id}`, dataTypesArray)

            if (overrideUserType) {
                url = getUrlWithDataTypes(`${endpoint1}/${overrideUserType}/${id}`, dataTypesArray)
            }

            // if (targetType) {
            //     url = getUrlWithDataTypes(`${endpoint1}/${userType}/${targetType}/${id}`, dataTypesArray)
            // }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        userTypes,
        targetTypes,
        list,
        get,
        create,
        update,
        remove
    }
}